import React,{Component} from 'react';
import PropTypes from 'prop-types';

import { Row, Col } from 'reactstrap';

import UpSVG from '../../../shared/assets/arrow-up.svg';
import DownSVG from '../../../shared/assets/arrow-down.svg';
import TrashSVG from '../../../shared/assets/trash.svg';

class EngagementTitle extends Component {
  handlePromoteClick(e){
    e.preventDefault();
    e.stopPropagation();
    this.props.onPromoteClick()
  }

  handleDemoteClick(e){
    e.preventDefault();
    e.stopPropagation();
    this.props.onDemoteClick();
  }

  handleDeleteClick(e){
    e.preventDefault();
    e.stopPropagation();
    this.props.onDeleteClick();
  }

  handleInfoClick(e){
    e.preventDefault();
  }

  render(){
    if(this.props.expanded){
      return (
        <Row>
          <Col xs='6'>
            <img 
              src={this.props.icon} 
              className='EngagementIcon' 
              alt='Engagement' 
            />
            <strong>&nbsp;&nbsp;{this.props.text}</strong>
          </Col>
          <Col xs='6'>
            <div className='pull-right'>
              <img
                src={UpSVG}
                className='EngagementIcon'
                onClick={(e) => this.handlePromoteClick(e)}
                alt='Up'
              />
              &nbsp;
              <img
                src={DownSVG}
                className='EngagementIcon'
                onClick={(e) => this.handleDemoteClick(e)}
                alt='Down'
              />
              &nbsp;
              <img
                src={TrashSVG}
                className='EngagementIcon'
                onClick={(e) => this.handleDeleteClick(e)}
                alt='Trash'
              />
            </div>
          </Col>
        </Row>
      )
    } else {
      return (
        <Row>
          <Col xs='12'>
            <img 
              src={this.props.icon} 
              className='EngagmentIcon' 
              alt='Activity'
            />
            <strong>&nbsp;&nbsp;{this.props.text}</strong>
          </Col>
        </Row>
      )
    }
  }
}

EngagementTitle.propTypes = {
  icon:PropTypes.string.isRequired,
  expanded:PropTypes.bool.isRequired,
  valid:PropTypes.bool.isRequired,
  text:PropTypes.string.isRequired,
  onPromoteClick:PropTypes.func.isRequired,
  onDemoteClick:PropTypes.func.isRequired,
  onDeleteClick:PropTypes.func.isRequired
}

export default EngagementTitle;



// WEBPACK FOOTER //
// ./src/routes/GuidedCampaignCreation/components/EngagementTitle.js